import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { useState } from 'react'
import { Wrapper } from './styled'
import AssociatedCourses from './associatedCourses'

interface IProps {
  data: string[]
}

const Courses = ({ data }: IProps) => {
  const translatePrefix = 'administration.certificate.list.create.table'
  const { t } = useTranslation()
  const [isWatching, setIsWatching] = useState(false)

  return (
    <Wrapper>
      {data.length ? (
        <span onClick={() => setIsWatching(true)}>
          {`${data.length} ${
            data.length === 1
              ? t(`${translatePrefix}.headers.associatedCourses`)
              : t(`${translatePrefix}.headers.associatedCoursesPlural`)
          }`}
          <FontAwesomeIcon icon={faEye} />
        </span>
      ) : (
        '--'
      )}
      {isWatching && (
        <AssociatedCourses data={data} close={() => setIsWatching(false)} />
      )}
    </Wrapper>
  )
}

export default Courses
